import { useState } from "react";

const PREVIEW_LIMIT = 50_000;
export function ProposalFileActions({value, filename="diggingbeagle-proposal.json"}:{value:string;filename?:string}) {
  const [open,setOpen] = useState(false);
  const [status,setStatus] = useState("");
  const copy = async () => {
    try { await navigator.clipboard.writeText(value); setStatus("JSON copied."); }
    catch { setStatus("Clipboard unavailable. Open the editor to copy manually."); }
  };
  const download = () => {
    // No remote URL: create a real local file from the current editor contents.
    const blob = new Blob([value],{type:"application/json;charset=utf-8"});
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href=url;
    link.download=/^[a-zA-Z0-9][a-zA-Z0-9._-]{0,120}\.json$/.test(filename)?filename:"diggingbeagle-proposal.json";
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(()=>URL.revokeObjectURL(url),1000);
    setStatus("Download requested. Validate the Proposal before importing.");
  };
  if (!value.trim()) return null;
  return <div className="proposal-file-actions">
    <div className="actions">
      <button type="button" className="subtle" onClick={()=>setOpen(v=>!v)} aria-expanded={open}>{open?"Close viewer":"Open viewer"}</button>
      <button type="button" className="subtle" onClick={()=>void copy()}>Copy JSON</button>
      <button type="button" className="subtle" onClick={download}>Download JSON</button>
    </div>
    {open&&<div className="proposal-file-preview"><p className="muted">Read-only preview. The full content remains in the CodeMirror editor and in Copy / Download. This does not validate or import anything.</p>
      <pre>{value.length>PREVIEW_LIMIT ? `${value.slice(0,PREVIEW_LIMIT)}\n[Preview truncated; download or copy the full JSON]` : value}</pre>
    </div>}
    {status&&<p role="status" className="muted">{status}</p>}
  </div>;
}
